import { TypePrestation } from './type-prestation';
import { User } from './user';
import { Contact } from './contact';
import { ExpertiseLight } from './expertise-light';
import * as moment from 'moment';
/*

 * @property int $id
 * @property int $expertise_id
 * @property int $type_prestation_id
 * @property int $user_id
 * @property string $date_prestation
 * @property string $quantity
 * @property string $comment
 * @property int $created_at
 * @property int $updated_at
 * @property int $created_by
 * @property int $updated_by
 *
 * @property Expertise $expertise
 * @property TypePrestation $typePrestation
 * @property User $user
 */

export class Prestation {

	public id: number;
	public quantity: number;
	public comment: string;
  public workflow: any;

	public _expertise: ExpertiseLight;
	public _type: TypePrestation;
	public _user: User;
	public _date_prestation: Date;
  
  	constructor(
  	) {
        this._type = new TypePrestation;
        this._user = new User;
        this._date_prestation = new Date;      
    }

  	set type(t: any) {
  		if (typeof t === 'number') {
  			this._type = Object.assign((new TypePrestation),{id: t});
  		} else if (t instanceof TypePrestation ) {
  			this._type = t;
  		} else {
  			this._type = Object.assign((new TypePrestation),t);
  		}
  	}

  	get type(): any {
  		return this._type;
  	}
    set expertise(t: any) {
      if (typeof t === 'number') {
        this._expertise = Object.assign((new ExpertiseLight),{id: t});
      } else if (t instanceof ExpertiseLight ) {
        this._expertise = t;
      } else {
        this._expertise = Object.assign((new ExpertiseLight),t);
      }
    }

    get expertise(): any {
      return this._expertise;
    }
  	set date_prestation(t: any) {
  		
  		if (typeof t === 'string') {
  			this._date_prestation = moment(t).toDate();
  		} else if (t instanceof Date ) {
  			this._date_prestation = t;
  		}
  	}

  	get date_prestation(): any {
  		return this._date_prestation;
  	}
  	get date_prestationStr(): any {
  		return moment(this._date_prestation).format('YYYY-MM-DD');
  	}



  	public toRequest(): any {
  		
  		let a = Object.assign({},{
        id: this.id || null,
        comment: this.comment || null,
        quantity: this.quantity || null,
        user_id: this.user.id || null,
        date_prestation: this.date_prestationStr || null,
        type_prestation_id: this.type.id || null,
        expertise_id: this.expertise || null
  		});
  		return a;
  	}

    get user(): any {
      return this._user;
    }

    get userSelect(): any {
      return this._user.id;
    }

    set userSelect(id: any) {
      this._user = Object.assign((new User),{id: id});
    }

    set user(t: any) {
      
      if (typeof t === 'number') {
        this._user = Object.assign((new User),{id: t});
      } else if (t instanceof User ) {
        this._user = t;
      } else {
        this._user = Object.assign(this._user,t);
      }
    }




}
